(function () {

    a3_pilot_reports.directive('pilotFunction', pilotFunction);

       /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name pilotFunction
   * @restrict E
   * @description
   *   Initialize panel with pm/pf and seating info : Only for pilots in flight courses
   * @example
   *   Usage:
   *   <pilot-positions></pilot-positions>
   * @ngInject
   */

    function pilotFunction(FlightFactory, UserFactory, $timeout) {
        function link(scope, attrs, $routeParams) {

            scope.selectSeat = selectSeat;
            scope.selectFunction = selectFunction;
            scope.reloadPilotFunction = false;          
            scope.handleMultipleFunctions = handleMultipleFunctions;

            var date = scope.crewRouteDuty.date;
            var courseId = scope.dutyCourse.Id;
            // var crewRouteCourse = scope.crewRouteDuty.Courses.find(x => x.CourseId == courseId && new moment(x.Date).isSame(date));

            var simpleCourseId = scope.dutyCourse.Id;

            var crewRouteCourse;
            if (scope.PhaseId != undefined && scope.PhaseId != null && !isNaN(scope.PhaseId)  && !isNaN(scope.PhaseId)) {
                 crewRouteCourse = scope.crewRouteDuty.Courses.find(x => x.PhaseId == scope.PhaseId && new moment(x.Date).isSame(date));
            } else {
                 crewRouteCourse = scope.crewRouteDuty.Courses.find(x => x.CourseId == simpleCourseId && new moment(x.Date).isSame(date));
            }
            
            var trainingFlightIds = crewRouteCourse.TrainingFlightIds;

            var trainingFlights = [];
            trainingFlightIds.forEach(function(flightId){
                trainingFlights.push(FlightFactory.getFlightFromStorage(flightId));
            });
            
            
            var instructor = UserFactory.getUser();
            var instructorTrainingIndicator = trainingFlights[0].crew.find(x => x.id == instructor.id).TrainingIndicatorCode;
            var traineeTrainingIndicator = instructorTrainingIndicator.toLowerCase();

            scope.flights = trainingFlights;
           
            trainingFlights.forEach(function(flight){
                flight.hasTwoTrainees = flight.crew.filter(x => x.TrainingIndicatorCode && x.TrainingIndicatorCode == traineeTrainingIndicator && !x.isDHC && x.IsTrainee).length == 2;
                flight.hasMoreThanThreePilots = flight.crew.filter(x => x.TrainingIndicatorCode && !x.isDHC).length>3;
            });

            initializePilotFunctions();

            //Operating pilots can change in each sector
            //When multiple trainees, instructor is not operating
            trainingFlights.forEach(function(flight){
                //Assign operatingPilots on each flight
                flight.operatingPilots = flight.hasMoreThanThreePilots || flight.hasTwoTrainees 
                                                ? scope.course.PilotFunctions.filter(x => !x.IsInstructor)
                                                : scope.course.PilotFunctions.filter(x => !x.Sectors.find(sec => sec.FlightId == flight.FlightId).NonApplicable);
            });         

            function initializePilotFunctions(){
                var PilotFunctions = [];
                if(scope.course && scope.trainees.length){
                    //Create trainee info
                    scope.trainees.forEach(function(trainee){
                        nameArray = trainee.Name.split(/[ ]+/);
                        var pilot = {
                            CrewId : trainee.CrewId,
                            AimsId : trainee.AimsId,
                            Name : trainee.Name,
                            FirstName: nameArray[1],
                            LastName: nameArray[0],
                            IsInstructor: false,
                            Sectors: createLegInfo(trainee.CrewId, trainee)
                        };

                        PilotFunctions.push(pilot);
                    });

                    //Create instructor info
                    var nameArray = instructor.name.split(/[ ]+/);

                    var pilot = {
                        CrewId : instructor.id,
                        AimsId : instructor.aimsId,
                        Name : instructor.name,
                        FirstName: nameArray[1],
                        LastName: nameArray[0],
                        IsInstructor: true,
                        Sectors : createLegInfo(instructor.id)        
                    };
    
                    PilotFunctions.push(pilot);

                    //make only one pilot flying
                    trainingFlights.forEach(function(flight){
                        var sectors = [];
                        PilotFunctions.forEach(function(pilot){
                            var pilotSector = pilot.Sectors.find(sec => sec.FlightId == flight.FlightId);
                            if(pilotSector && !pilotSector.NonApplicable){
                                sectors.push(pilotSector);  
                            }
                        })
                        if(sectors.length > 1) {
                            sectors[0].isPM = true;
                        }                      
                    });

                    //Apply existing saved info
                    if(scope.course.PilotFunctions){
                        PilotFunctions.forEach(function(pilot){
                            var existingInfo = scope.course.PilotFunctions.find(x => x.CrewId == pilot.CrewId);
                            if(existingInfo){

                                pilot.Seat = existingInfo.Seat;

                                var sectors = [];
                                pilot.Sectors.forEach(function(incomingSector){
                                    var existingSector = existingInfo.Sectors.find(x => x.FlightId == incomingSector.FlightId && x.Arrival == incomingSector.Arrival && x.Departure == incomingSector.Departure);
                                    
                                    if(existingSector){
                                        var sector = deepCopy(existingSector);
                                        sector.NonApplicable = incomingSector.NonApplicable;
                                        sector.SeatOptions = incomingSector.SeatOptions;

                                        if(!incomingSector.SeatOptions.includes(sector.Seat)){
                                            sector.Seat = incomingSector.Seat;
                                        }

                                        sectors.push(sector);
                                    }
                                    else{
                                        sectors.push(incomingSector); 
                                    }
                                });

                                pilot.Sectors = sectors;
                            }
                        })
                    }
                    
                    scope.reloadPilotFunction = true;
                }
                scope.course.PilotFunctions = PilotFunctions;

                console.log(PilotFunctions);
            }
            

            scope.instructor = instructor;

            function deepCopy(originalObject) {
                return JSON.parse(JSON.stringify(originalObject));
            }

            function createLegInfo(crewId, trainee){
                var legs = [];

                var traineeSeatOptions = ['Right', 'Left', 'Jumpseat'];
                var instructorSeatOptions = ['Right', 'Left', 'Jumpseat'];

                trainingFlights.forEach(function(flight){
                    var leg = {
                        CrewId : crewId,
                        FlightId : flight.FlightId,
                        Departure: flight.Departure,
                        Arrival: flight.Arrival,
                        isPM: false,
                        NonApplicable : trainee ? false : (flight.hasMoreThanThreePilots || flight.hasTwoTrainees),
                        SeatOptions: (flight.hasMoreThanThreePilots || flight.hasTwoTrainees) ? instructorSeatOptions : traineeSeatOptions
                    };

                    if(trainee){
                        leg.Seat = flight.hasMoreThanThreePilots || flight.hasTwoTrainees ? undefined : 'Right';
                    }
                    else{
                        leg.Seat = flight.hasMoreThanThreePilots || flight.hasTwoTrainees ? 'Jumpseat' : 'Left'; 
                    }

                    legs.push(leg);
                });

                if(trainee){
                    // Get only the flights trainee is a participant of
                    var traineeFlightIds = [];
                    trainingFlights.forEach(function(flight){
                        var crewMember = flight.crew.find(x => x.id == trainee.CrewId);
                        if(crewMember && crewMember.TrainingIndicatorCode && crewMember.TrainingIndicatorCode == traineeTrainingIndicator){
                            traineeFlightIds.push(flight.FlightId);
                        }
                    });

                    var nonActiveLegs = legs.filter(l => !traineeFlightIds.includes(l.FlightId));
                    nonActiveLegs.forEach(function(nonActiveLeg){
                        nonActiveLeg.NonApplicable = true;
                    });
                }

                return legs;
            } 

            function selectSeat(flight, pilot, leg) {
                var otherPilotId = flight.operatingPilots.find(x => x.CrewId !== pilot.CrewId)?.CrewId;
                if (otherPilotId !== "") {
                    var otherPilot = scope.course.PilotFunctions.find(x => x.CrewId == otherPilotId);
                }
                if (otherPilot != null) {
                    var otherSector = otherPilot.Sectors.find(x => x.FlightId == leg.FlightId);
                }

                if (flight.hasTwoTrainees || flight.hasMoreThanThreePilots) {
                    if (leg.Seat === 'Jumpseat') {
                        // Automatically select 'N/A' when the seat is 'Jumpseat'
                        leg.NonApplicable = true; // Optionally, set NonApplicable to true for 'N/A'
                    } else if (leg.Seat === 'Right' || leg.Seat === 'Left') {
                        // Deactivate 'N/A' when the seat is 'Right' or 'Left'
                        leg.NonApplicable = false;
                    } else {
                        // Handle other seat selections as needed
                        otherSector.Seat = leg.Seat;
                        leg.NonApplicable = false;
                    }
                }
            }
            
            function selectFunction(flight, pilot, leg){
                var otherPilotId = flight.operatingPilots.find(x => x.CrewId != pilot.CrewId).CrewId;
                var otherPilot = scope.course.PilotFunctions.find(x => x.CrewId == otherPilotId);
                var otherSector = otherPilot.Sectors.find(x => x.FlightId == leg.FlightId);

                if(leg.isPM){otherSector.isPM = false; }
                else{ otherSector.isPM = true;}
            }
            
            scope.handleFunctions = handleFunctions;
            scope.checkboxValue = false;

            function handleFunctions(flight, pilot, leg) {
                var otherPilotId = flight.operatingPilots.find(x => x.CrewId != pilot.CrewId).CrewId;
                var otherPilot = scope.course.PilotFunctions.find(x => x.CrewId == otherPilotId);
                var otherSector = otherPilot.Sectors.find(x => x.FlightId == leg.FlightId);

                if (flight.hasTwoTrainees) {
                    if (leg.NonApplicable) {
                        leg.Seat = "Jumpseat";
                        otherSector.NonApplicable = false;
                        pilot.Sectors.find(x => x.FlightId == leg.FlightId).isPM = '';
                    } else {
                        pilot.Sectors.find(x => x.FlightId == leg.FlightId).NonApplicable = '';
                        leg.Seat = "";
                    }
                }
            }      

            function handleMultipleFunctions(flight, pilot, leg) {
                var operatingPilot = flight.operatingPilots.find(x => x.CrewId != pilot.CrewId);
                var operatingPilotId;
                var otherPilot;
                var otherSector;
                if(operatingPilot){
                    operatingPilotId = operatingPilot.CrewId;
                    otherPilot = scope.course.PilotFunctions.find(x => x.CrewId == operatingPilotId);
                    otherSector = otherPilot.Sectors.find(x => x.FlightId == leg.FlightId);
                }
            
                if (otherSector && leg.NonApplicable) {
                    leg.Seat = "Jumpseat";
                    otherSector.NonApplicable = false;
                    pilot.Sectors.find(x => x.FlightId == leg.FlightId).isPM = '';
                }
                if(!leg.NonApplicable){
                    leg.Seat = "";
                }
            }
        }

        return {
            restrict: 'E',
            templateUrl: "views/Training/pilotFunctionPanel.tpl.html",
            scope : false,
            terminal: true,
            link: link
        }
    }
})();
